module.exports = __webpack_public_path__ + "static/img/jinan-index.c1f0c661.jpg";